import React, { Fragment } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as CommonService from '../../../services/CommonService';
import { components } from 'react-select';
import { Spin } from 'antd';

export default (props) => {

	const { handleSelect, endpoint, dataOption, customOption, indicator, endpointParam = {} } = props;

	const loadOptions = async (searchQuery, loadedOptions, { page }) => {
		const response = await CommonService.get(endpoint, {
			...endpointParam,
			value: searchQuery,
			page: page || 0,
			size: 10
		});

		const contents = response.data?.contents || [];

		const options = contents.map((item) => dataOption ? dataOption(item) : ({
			label: `${item.name} - ${item?.phoneNumber || 'SĐT chưa xác định'}`,
			value: item.id,
			data: item
		}));

		const hasMore = (page || 0) < response.data?.totalPages;

		return {
			options,
			hasMore,
			additional: {
				page: (page || 0) + 1
			}
		};
	};

	const renderCustomComponent = () => {
		const obj = {};
		if (customOption) {
			obj.Option = CustomOption;
		}
		if (indicator) {
			obj.IndicatorsContainer = CustomIndicatorsContainer;
		}
		return obj;
	};

	const CustomIndicatorsContainer = (props) => {

		return (
			<components.IndicatorsContainer {...props}>
				{props.children}
				<div
					onMouseDown={(e) => {
						e.stopPropagation();
					}}
					style={{
						padding: '0 8px',
						cursor: 'pointer',
						color: '#1890ff',
						fontWeight: 'bold'
					}}
				>
					{indicator()}
				</div>
			</components.IndicatorsContainer>
		);
	};

	const CustomOption = (props) => {
		return (
			<components.Option {...props}>
				{customOption(props.data)}
			</components.Option>
		);
	};

	return <Fragment>
		<AsyncPaginate
			className={'async-paginate'}
			isClearable={true}
			loadOptions={loadOptions}
			loadingMessage={() => <Spin size="small" />}
			components={renderCustomComponent()}
			onChange={handleSelect}
			additional={{ page: 0 }}
			debounceTimeout={300}
			{...props}
		/>
	</Fragment>;
}
